import Loading from "../../../../../../components/Loading";
import TicketsList from "../../../../../../components/TicketsList";
import useTickets from "./useTickets";


export default function Tickets() {

    const {
        isLoading,
        tickets,
        loadMore,
        hasMore
    } = useTickets();

    return (
        <Loading loading={isLoading} >
            <TicketsList
                paginated
                tickets={tickets}
                loadMore={loadMore}
                hasMore={hasMore}
                isLoading={isLoading}
                emptyListMessage="Não há bilhetes concorrendo neste sorteio"
            />
        </Loading >
    )
}
